import {
  FACILITATOR_SHOW_VIDEO,
  SET_SELECTED_FACILITATOR_ROUTE,
  IS_OPEN_PREMIUM_SUBSCRIPTION_DIALOG,
  IS_OPEN_FACILITATOR_ACCOUNT_SETTINGS_DIALOG,
  IS_OPEN_CREATE_MEETING_DIALOG,
  IS_OPEN_MURAL_AUTH_DIALOG,
  SHOW_APP_OVERLAY_SPINNER,
  IS_OPEN_INFO_DIALOG,
  SET_INFO_DIALOG_CONTENT,
  CLOSE_INFO_DIALOG,
} from '../types/facilitatorSessionTypes';
import { getStoredFacilitatorRouteKey } from 'utils/localStorageUtils';

/**
 * Shows or hides the facilitator meeting video
 * @param {bool} showVideo
 */
export const updateShowVideo = showVideo => {
  return {
    type: FACILITATOR_SHOW_VIDEO,
    payload: showVideo,
  };
};

/**
 * Set global info dialog open or closed
 * @param {boolean} isOpenInfoDialog
 */
export const openInfoDialog = isOpenInfoDialog => {
  return {
    type: IS_OPEN_INFO_DIALOG,
    payload: isOpenInfoDialog,
  };
};

/**
 * Close and clear the info dialog
 */
export const closeInfoDialog = () => {
  return {
    type: CLOSE_INFO_DIALOG,
  };
};

/**
 * Set global info dialog content
 * @param {string} title
 * @param {string} content // html string
 */
export const setInfoDialogContent = ({ title, content }) => {
  return {
    type: SET_INFO_DIALOG_CONTENT,
    payload: { title, content },
  };
};

/**
 * Set app overlay spinner to show or not
 * @param {boolean} showAppOverlaySpinner
 */
export const showAppOverlaySpinner = showAppOverlaySpinner => {
  return {
    type: SHOW_APP_OVERLAY_SPINNER,
    payload: showAppOverlaySpinner,
  };
};

/**
 * Set account settings dialog open or closed
 * @param {boolean} isOpenAccountSettingsDialog
 */
export const openFacilitatorAccountSettingsDialog = isOpenAccountSettingsDialog => {
  return {
    type: IS_OPEN_FACILITATOR_ACCOUNT_SETTINGS_DIALOG,
    payload: isOpenAccountSettingsDialog,
  };
};

/**
 * Set account settings dialog open or closed
 * @param {boolean} isOpenCreateSessionDialog
 */
export const openMuralAuthDialog = isOpenMuralAuthDialog => {
  return {
    type: IS_OPEN_MURAL_AUTH_DIALOG,
    payload: isOpenMuralAuthDialog,
  };
};

/**
 * Set account settings dialog open or closed
 * @param {boolean} isOpenCreateSessionDialog
 */
export const openCreateSessionDialog = isOpenCreateSessionDialog => {
  return {
    type: IS_OPEN_CREATE_MEETING_DIALOG,
    payload: isOpenCreateSessionDialog,
  };
};
